<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header" id="modalTitle">Alert</header>
        <section class="modal-body" id="modalDescription">
          <div class="modal-content" ref="videoPlayerWrapperRef">
            <div class="modal-content-title">
              <span class="material-icons warning-icon">warning</span>
              <p>Confirm Selection</p>
            </div>
            <div class="modal-content-body">
              This option is not compatible with your previous selection. If you
              continue, all other selections will be cleared out.
            </div>
            <div class="modal-btn-group">
              <button class="cancel-btn" @click="close">Cancel</button>
              <button v-if="!isMobile()" class="continue-btn" @click="continueUpdate">Continue</button>
              <button v-else class="continue-btn" @click="continueUpdate(); scrollToTop()">Continue</button>
            </div>
          </div>
        </section>
        <footer class="modal-footer"></footer>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "ProductOptionsModal",
  props: {},
  data() {
    return {};
  },
  created() {
    const onEscape = e => {
      if (e.keyCode === 27) {
        this.$emit("close");
      }
    };
    document.addEventListener("keydown", onEscape);
    this.$once("hook:destroyed", () => {
      document.removeEventListener("keydown", onEscape);
    });
  },
  methods: {
    close() {
      this.$emit("close");
    },
    continueUpdate() {
      this.$emit("continueUpdate");
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    isMobile() {
      if (screen.width <= 767) {
        return true;
      } else {
        return false;
      }
    }
  },
  components: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
  height: 46px;
  align-items: center;
}

.modal-footer {
  justify-content: center;
}

.modal-body {
  position: relative;
  height: 100%;
}

.btn-close {
  border: none;
  cursor: pointer;
  background: transparent;
  color: rgb(60, 95, 104);
  font-size: 16px;
  font-family: $font-weight-normal;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  line-height: 24px;
  height: 22px;
  padding-left: 0px;
}

.modal-content {
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
  padding: 0;
  width: 90%;
  border-radius: 0px;
  border: 1px solid rgb(216, 216, 216);
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.3);

  @include media-breakpoint-up(md) {
    width: 600px;
  }
}

.close-icon {
  color: #fff;
  z-index: 10;
  position: absolute;
  right: 0;
  cursor: pointer;
}

.close-icon-wrapper {
  position: relative;
  height: 15px;
}

.modal-content-title {
  p {
    font-family: $font-weight-medium;
    color: rgb(0, 0, 0);
    font-size: 28px;
    font-weight: 500;
    letter-spacing: 0.25px;
    margin: 0 0 0 10px;
  }

  .warning-icon {
    font-size: 30px;
    color: rgb(0, 0, 0);
  }

  padding: 12px 30px;
  background: rgba(254, 217, 0, 0.6);
  display: flex;
  align-items: center;
}

.modal-content-body {
  color: rgb(51, 51, 51);
  font-size: 20px;
  letter-spacing: 0.25px;
  line-height: 30px;
  padding: 30px;
  font-family: $font-weight-normal;
}
.modal-btn-group {
  padding: 0 30px 30px 0;
  display: flex;
  justify-content: flex-end;
}

.continue-btn {
  border: solid 1px #25c0d0;
  color: #fff;
  display: block;
  font-size: 16px;
  font-weight: bold;
  height: 48px;
  line-height: 24px;
  padding: 12px 30px;
  white-space: nowrap;
  text-transform: uppercase;
  background: rgb(37, 192, 208);
  border-radius: 0px;
  font-family: $font-weight-bold;
  letter-spacing: 0.75px;
}
.cancel-btn {
  border: 0;
  color: #25c0d0;
  display: block;
  font-size: 16px;
  font-weight: bold;
  height: 48px;
  line-height: 24px;
  padding: 12px 30px;
  white-space: nowrap;
  background: #fff;
  text-transform: uppercase;
  border-radius: 0px;
  font-family: $font-weight-bold;
  letter-spacing: 0.75px;
}
</style>
